import { createAction } from 'actions/utils';
import {
    GET_DEVICE_CACHE_REQUEST,
    GET_DEVICE_CACHE_SUCCESS,
    GET_DEVICE_CACHE_ERROR,
    SET_DEVICE_CACHE_REQUEST,
    SET_DEVICE_CACHE_SUCCESS,
    SET_DEVICE_CACHE_ERROR,
} from 'constants/ActionTypes';
import { Core } from 'managers';

export function getDeviceCache() {
    return (dispatch) => {
        dispatch(createAction(GET_DEVICE_CACHE_REQUEST, {}));
        return Core.deviceCacheManager.getDeviceCache().then(
            ({ data }) => {
                dispatch(createAction(GET_DEVICE_CACHE_SUCCESS, data || {}));
            },
            (error) => {
                dispatch(
                    createAction(GET_DEVICE_CACHE_ERROR, {
                        error: true,
                        errorType: error,
                    }),
                );
                throw error;
            },
        );
    };
}

export function setDeviceCache(data) {
    return (dispatch) => {
        dispatch(createAction(SET_DEVICE_CACHE_REQUEST, {}));
        return Core.deviceCacheManager.setDeviceCache({ data }).then(
            () => {
                dispatch(createAction(SET_DEVICE_CACHE_SUCCESS, data));
            },
            (error) => {
                dispatch(
                    createAction(SET_DEVICE_CACHE_ERROR, {
                        error: true,
                        errorType: error,
                    }),
                );
                throw error;
            },
        );
    };
}
